import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-table-view-button',
    templateUrl: './table-view-button.component.html',
    styleUrls: ['./table-view-button.component.css'],
    standalone: false
})
export class TableViewButtonComponent {

  @Input()
      imageSrc!: string;
      @Input()
      tooltip!: string;
      @Input() color: string = 'primary';
      @Output() buttonClick = new EventEmitter<void>();
  
      onClick() {
        this.buttonClick.emit();
      }

}
